module.exports = __webpack_public_path__ + "static/media/down_focussed.884f5437.svg";